import { IPageTabNavLink } from "../interfaces-and-types";

export const homeNavLinks: IPageTabNavLink[] = [
  {
    name: "Home",
    route: "",
  },
];
